// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"4f60b9de","2840":"a0cf56ad","4061":"92032edf","4774":"92032edf","7264":"37cf3500","8053":"4f60b9de","8285":"4f60b9de","9181":"4f60b9de"}[chunkId] + ".chunk.css";
};